<template>
  <div class="w-full flex-1-0-auto viewport-gutter pt-4 pb-16 xl:pb-32 header-height-top-space discover-text">
    <div class="container">
      <breadcrumb
        :title="tr(`pages.${pageType}.title`)"
        class="pb-5 xl:pb-10"
      />

      <h1 id="main-content" class="pt-5 xl:pt-10 text-3xl font-semibold leading-tight pb-6 xl:text-3.5xl xl:pb-10 text-4y-sky-blue font-lufthansa-head">
        {{ tr(`pages.${pageType}.title`) }}
      </h1>

      <div class="w-full max-w-212 text-sm xl:text-base">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{'pb-4 xl:pb-8': index < (items.length - 1) }"
        >
          <h2
            v-if="item.title"
            class="text-xl pb-4 font-bold text-4y-sky-blue font-lufthansa-head"
          >
            {{ item.title }}
          </h2>

          <p
            v-for="(description, descriptionIndex) in item.descriptions"
            :key="descriptionIndex"
            class="pb-6 content-block leading-7 text-lg"
            v-html="description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '~brand-components/discover/shared/breadcrumb.vue'
import TextSubpage from '~components/shared/text-subpage'

export default TextSubpage.extend({
  components: {
    Breadcrumb,
  },
})
</script>
<style lang="scss" scoped>
.discover-text::v-deep {
  h2 {
    @apply font-bold;

    margin-bottom: 14px;
  }

  a {
    @apply text-4y-nightsky-blue font-normal;

    &:hover {
      @apply underline;
    }
  }
}
</style>
